import React, { useState } from 'react'
import FollowingTabsModal from './FollowingTabsModal';
import SubscriptionsTabsModal from './SubscriptionsTabsModal';
import '../followingModal/FollowingModal.css'

const FollowingModal = () => {
    const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    <div className='modal-box-sec following-modal-sec'>
        <div className="modal fade" id="followingBackdrop1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div class="modal-body">
                        <div className="tabs-container">
                            <div className="tabs-header d-flex flex-wrap justify-content-center align-items-center gap-3">
                                <button  className={`tab-button d-flex align-items-center justify-content-center ${activeTab === 0 ? "active" : ""}`} onClick={() =>  setActiveTab(0)}>
                                <span className='text-btn'>Following</span>
                                </button>
                                <button   className={`tab-button  d-flex align-items-center justify-content-center ${activeTab === 1 ? "active" : ""}`} onClick={() =>  setActiveTab(1)}>
                                <span className='text-btn'>Subscriptions</span>
                                </button>
                            </div>

                            {/* Tab Content */}
                            <div className="tabs-content">
                            {activeTab === 0 && (
                                <div className="tab-panel">
                                    <FollowingTabsModal />
                                </div>
                            )}
                            {activeTab === 1 && (
                                <div className="tab-panel">
                                    <SubscriptionsTabsModal />
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FollowingModal